import { Routes } from '@angular/router';
import { authGuard } from './core/guards/auth.guard';
import { adminGuard } from './core/guards/admin.guard';

export const routes: Routes = [
  {
    path: '',
    loadComponent: () => import('./features/home/home.component').then(m => m.HomeComponent)
  },
  {
    path: 'packages',
    loadComponent: () => import('./features/packages/package-list/package-list.component').then(m => m.PackageListComponent)
  },
  {
    path: 'packages/:id',
    loadComponent: () => import('./features/packages/package-detail/package-detail.component').then(m => m.PackageDetailComponent)
  },
  // Auth Routes (ohne Header/Footer)
  {
    path: 'auth',
    children: [
      {
        path: 'login',
        loadComponent: () => import('./features/auth/login/login.component').then(m => m.LoginComponent)
      },
      {
        path: 'register',
        loadComponent: () => import('./features/auth/register/register.component').then(m => m.RegisterComponent)
      },
      {
        path: 'forgot-password',
        loadComponent: () => import('./features/auth/forgot-password/forgot-password.component').then(m => m.ForgotPasswordComponent)
      },
      {
        path: 'confirm-email',
        loadComponent: () => import('./features/auth/confirm-email/confirm-email.component').then(m => m.ConfirmEmailComponent)
      },
      {
        path: 'reset-password',
        loadComponent: () => import('./features/auth/reset-password/reset-password.component').then(m => m.ResetPasswordComponent)
      },
      {
        path: 'confirm-email-change',
        loadComponent: () => import('./features/auth/confirm-email-change/confirm-email-change.component').then(m => m.ConfirmEmailChangeComponent)
      },
      {
        path: 'homexpert-callback',
        loadComponent: () => import('./features/auth/homexpert-callback/homexpert-callback.component').then(m => m.HomeXpertCallbackComponent)
      },
      {
        path: 'link-account',
        loadComponent: () => import('./features/auth/link-account/link-account.component').then(m => m.LinkAccountComponent)
      }
    ]
  },
  // Redirect alte Pfade
  {
    path: 'login',
    redirectTo: 'auth/login',
    pathMatch: 'full'
  },
  {
    path: 'register',
    redirectTo: 'auth/register',
    pathMatch: 'full'
  },
  {
    path: 'profile',
    loadComponent: () => import('./features/profile/profile.component').then(m => m.ProfileComponent),
    canActivate: [authGuard]
  },
  {
    path: 'cart',
    loadComponent: () => import('./features/cart/cart-page/cart-page.component').then(m => m.CartPageComponent),
    canActivate: [authGuard]
  },
  {
    path: 'checkout',
    loadComponent: () => import('./features/checkout/checkout-page.component').then(m => m.CheckoutPageComponent),
    canActivate: [authGuard]
  },
  {
    path: 'inventory',
    loadComponent: () => import('./features/inventory/inventory-page/inventory-page.component').then(m => m.InventoryPageComponent),
    canActivate: [authGuard]
  },
  {
    path: 'my-packages',
    loadComponent: () => import('./features/my-packages/my-packages.component').then(m => m.MyPackagesComponent),
    canActivate: [authGuard]
  },
  {
    path: 'my-packages/:id',
    loadComponent: () => import('./features/my-packages/package-activations/package-activations.component').then(m => m.PackageActivationsComponent),
    canActivate: [authGuard]
  },
  // Admin Routes
  {
    path: 'admin',
    canActivate: [adminGuard],
    loadComponent: () => import('./features/admin/admin-layout/admin-layout.component').then(m => m.AdminLayoutComponent),
    children: [
      {
        path: '',
        redirectTo: 'dashboard',
        pathMatch: 'full'
      },
      {
        path: 'dashboard',
        loadComponent: () => import('./features/admin/dashboard/admin-dashboard.component').then(m => m.AdminDashboardComponent)
      },
      {
        path: 'mdt-login',
        loadComponent: () => import('./features/admin/mdt-login/mdt-login.component').then(m => m.MdtLoginComponent)
      },
      // Paketverwaltung
      {
        path: 'packages',
        loadComponent: () => import('./features/admin/packages/package-admin-list/package-admin-list.component').then(m => m.PackageAdminListComponent)
      },
      {
        path: 'packages/create',
        loadComponent: () => import('./features/admin/packages/package-admin-edit/package-admin-edit.component').then(m => m.PackageAdminEditComponent)
      },
      {
        path: 'packages/:id',
        loadComponent: () => import('./features/admin/packages/package-admin-edit/package-admin-edit.component').then(m => m.PackageAdminEditComponent)
      },
      // Produktverwaltung (Paket-Produkte)
      {
        path: 'package-products',
        loadComponent: () => import('./features/admin/package-products/package-product-list/package-product-list.component').then(m => m.PackageProductListComponent)
      },
      {
        path: 'package-products/create',
        loadComponent: () => import('./features/admin/package-products/package-product-edit/package-product-edit.component').then(m => m.PackageProductEditComponent)
      },
      {
        path: 'package-products/:id',
        loadComponent: () => import('./features/admin/package-products/package-product-edit/package-product-edit.component').then(m => m.PackageProductEditComponent)
      },
      // Benutzerverwaltung
      {
        path: 'users',
        loadComponent: () => import('./features/admin/user-management/user-admin-list/user-admin-list.component').then(m => m.UserAdminListComponent)
      },
      {
        path: 'users/:id',
        loadComponent: () => import('./features/admin/user-management/user-admin-detail/user-admin-detail.component').then(m => m.UserAdminDetailComponent)
      },
      // Bestellungen
      {
        path: 'orders',
        loadComponent: () => import('./features/admin/orders/admin-orders.component').then(m => m.AdminOrdersComponent)
      },
      // Gutscheine
      {
        path: 'vouchers',
        loadComponent: () => import('./features/admin/vouchers/admin-vouchers.component').then(m => m.AdminVouchersComponent)
      },
      // Videos (Startseite)
      {
        path: 'videos',
        loadComponent: () => import('./features/admin/videos/video-list/video-list.component').then(m => m.VideoListComponent)
      },
      {
        path: 'videos/new',
        loadComponent: () => import('./features/admin/videos/video-edit/video-edit.component').then(m => m.VideoEditComponent)
      },
      {
        path: 'videos/:id',
        loadComponent: () => import('./features/admin/videos/video-edit/video-edit.component').then(m => m.VideoEditComponent)
      },
      // Geräteprofile (MDT Products)
      {
        path: 'device-profiles',
        loadComponent: () => import('./features/admin/device-profiles/device-profile-list/device-profile-list.component').then(m => m.DeviceProfileListComponent)
      },
      {
        path: 'device-profiles/upload',
        loadComponent: () => import('./features/admin/device-profiles/device-profile-upload/device-profile-upload.component').then(m => m.DeviceProfileUploadComponent)
      },
      {
        path: 'device-profiles/:id',
        loadComponent: () => import('./features/admin/device-profiles/device-profile-detail/device-profile-detail.component').then(m => m.DeviceProfileDetailComponent)
      },
      // Legacy routes (alte Produkt-Verwaltung für Kompatibilität)
      {
        path: 'products',
        redirectTo: 'device-profiles',
        pathMatch: 'full'
      },
      {
        path: 'products/upload',
        redirectTo: 'device-profiles/upload',
        pathMatch: 'full'
      },
      {
        path: 'products/:id',
        loadComponent: () => import('./features/admin/products/product-detail/product-detail.component').then(m => m.ProductDetailComponent)
      }
    ]
  },
  {
    path: 'datenschutz',
    loadComponent: () => import('./features/legal/datenschutz/datenschutz.component').then(m => m.DatenschutzComponent)
  },
  {
    path: 'impressum',
    loadComponent: () => import('./features/legal/impressum/impressum.component').then(m => m.ImpressumComponent)
  },
  {
    path: 'so-funktioniert-es',
    loadComponent: () => import('./features/how-it-works/how-it-works.component').then(m => m.HowItWorksComponent)
  },
  {
    path: 'faq',
    loadComponent: () => import('./features/faq/faq.component').then(m => m.FaqComponent)
  },
  {
    path: '**',
    redirectTo: ''
  }
];
